import React, { useEffect, useContext } from "react";
import JSConfetti from 'js-confetti'
import { ThemeContext } from "./ThemeContext";

function ConfettiContainer() {

    const {launchEmojis, setLaunchEmojis} = useContext(ThemeContext) 

    const jsConfetti = new JSConfetti()

    if (launchEmojis){
    jsConfetti.addConfettiAtPosition({
       emojis:['🌸', '🌼', '🌷', '💐', '❤️', '💖', '💜', '💙', '💛'],
       confettiDispatchPosition: {
            x: window.innerWidth/2,
            y: 0
        }
    },[])
    }
}

export default ConfettiContainer;